import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Card, CardContent, makeStyles, Grid, Typography, Chip } from "@material-ui/core";
import {
	formatDate,
	isNotNullOrEmpty,
	capitalizeFirstLetter,
	isStaffUser,
	useLookup,
} from "utils";
import {
	CrudOptions,
	FormActions,
	FormButton,
	FormSubmitButton,
} from "frame/components";

const useStyles = makeStyles((theme) => ({
	body: {
		marginTop: theme.spacing(2),
		[theme.breakpoints.down("xs")]: {
			marginTop: theme.spacing(3),
		},
	},
	card: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		position: "relative",
		marginBottom: theme.spacing(2),
	},
	content: {
		padding: theme.spacing(1, 3),
		flexGrow: 1,
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			flexWrap: "wrap",
		},
		[theme.breakpoints.down("xs")]: {
			marginBottom: theme.spacing(4),
		},
		"&:last-child": {
			paddingBottom: theme.spacing(2),
		},
	},
	error: {
		backgroundColor: theme.palette.error.main,
		color: theme.palette.white,
	},
	success: {
		backgroundColor: theme.palette.success.main,
		color: theme.palette.white,
	},
}));

const LeaveTypeListing = ({
	leaveTypes = [],
	isLoading = false,
	onEdit,
	onDelete
}) => {
	const classes = useStyles();

	return (
		<>
			{
				leaveTypes && leaveTypes.length > 0 && !isLoading ?
					leaveTypes.map((leaveType, index) => (
						<Card
							data-cy={`leave-type-${index}`}
							className={clsx(classes.card)}
							key={index}
						>
							<CardContent className={classes.content}>
								<Grid
									container
									spacing={2}
									className={classes.container}
								>
									<Grid item lg={8} md={6} xs={12}>
										<Typography
											className={classes.label}
											variant="body2"
										>
										Type Name
										</Typography>
										<Typography variant="h5">
											{leaveType.leaveType || "-"}
										</Typography>
									</Grid>
									<Grid item lg={4} md={6} xs={12}>
										<Typography variant="body2" className={classes.label}>
										Status
										</Typography>
										<Chip
											className={
												leaveType.active
													? classes.success
													: classes.error
											}
											size="small"
											label={
												leaveType.active
													? "Active"
													: "Inactive"
											}
										/>
									</Grid>
								</Grid>
								<div className="ignore">
									<CrudOptions
										onDelete={() => onDelete(leaveType.id)}
										onEdit={() => onEdit(leaveType.id)}
									/>
								</div>
							</CardContent>
						</Card>
					))
					:
					<Card
						data-cy={`leave-type-empty`}
						className={clsx(classes.card, undefined)}
					>
						<CardContent className={classes.content}>
							<Grid
								container
								spacing={2}
								className={clsx(
									classes.container,
									classes.clickable
								)}
							>
								<Grid item lg={3} md={6} xs={12}>
									<Typography
										className={classes.label}
										variant="body2"
									>
										{ isLoading ? "Loading..." : "No leave types to show" }
									</Typography>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
			}
		</>
	);
};

LeaveTypeListing.propTypes = {
	leaveTypes: PropTypes.array,
	isLoading: PropTypes.bool,
	onEdit: PropTypes.func,
	onDelete: PropTypes.func
};

export default LeaveTypeListing;
